import { Check } from "lucide-react";

// Reusable numbered 5-node progress (source-of-truth: post-onboarding journey).
// Steps 1..total. `current` is 1-indexed; steps before it render completed.
// completed = filled sage circle + white check; current = ivory interior,
// sage outline, number; future = light circle, muted number, light connector.
export const StepProgress = ({ total = 5, current = 1, className = "" }) => {
  return (
    <div className={`flex w-full items-center ${className}`} data-testid="step-progress">
      {Array.from({ length: total }).map((_, i) => {
        const step = i + 1;
        const state = step < current ? "done" : step === current ? "current" : "future";
        return (
          <div key={step} className="flex flex-1 items-center last:flex-none">
            <div
              data-testid={`step-node-${step}`}
              data-state={state}
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                state === "done"
                  ? "bg-primary text-primary-foreground"
                  : state === "current"
                  ? "border-2 border-primary bg-background text-primary"
                  : "border border-border bg-card text-muted-foreground/60"
              }`}
            >
              {state === "done" ? <Check className="h-4 w-4" strokeWidth={3} /> : step}
            </div>
            {step < total && (
              <div
                className={`mx-1.5 h-[2px] flex-1 rounded-full ${
                  step < current ? "bg-primary/70" : "bg-border"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
